import React from "react";
import Register from "components/Authentication/Register";

const RegisterPage = () => {
  return <Register />;
};

RegisterPage.title = "Register";

export default RegisterPage;
